// This is default dark theme from echart library.
// Only 'backgroundColor' property has been replaced to the background color which is used for darkMode

import { SchenckColors } from '@schenck/rotec-components';

// This theme can be adjusted with custom colors
export const CHART_DARK_THEME = {
  color: [
    '#dd6b66',
    '#759aa0',
    '#e69d87',
    '#8dc1a9',
    '#ea7e53',
    '#eedd78',
    '#73a373',
    '#73b9bc',
    '#7289ab',
    '#91ca8c',
    '#f49f42',
  ],
  backgroundColor: SchenckColors.SCHENCK_COLOR_GRAY_DARKER,
  textStyle: {},
  title: {
    textStyle: {
      color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
    },
    subtextStyle: {
      color: '#aaaaaa',
    },
  },
  line: {
    itemStyle: {
      borderWidth: 1,
    },
    lineStyle: {
      width: 2,
    },
    symbolSize: 4,
    symbol: 'circle',
    smooth: false,
  },
  radar: {
    itemStyle: {
      borderWidth: 1,
    },
    lineStyle: {
      width: 2,
    },
    symbolSize: 4,
    symbol: 'circle',
    smooth: false,
  },
  bar: {
    itemStyle: {
      barBorderWidth: 0,
      barBorderColor: '#ccc',
    },
  },
  pie: {
    itemStyle: {
      borderWidth: 0,
      borderColor: '#ccc',
    },
  },
  scatter: {
    itemStyle: {
      borderWidth: 0,
      borderColor: '#ccc',
    },
  },
  boxplot: {
    itemStyle: {
      borderWidth: 0,
      borderColor: '#ccc',
    },
  },
  parallel: {
    itemStyle: {
      borderWidth: 0,
      borderColor: '#ccc',
    },
  },
  sankey: {
    itemStyle: {
      borderWidth: 0,
      borderColor: '#ccc',
    },
  },
  funnel: {
    itemStyle: {
      borderWidth: 0,
      borderColor: '#ccc',
    },
  },
  gauge: {
    itemStyle: {
      borderWidth: 0,
      borderColor: '#ccc',
    },
  },
  candlestick: {
    itemStyle: {
      color: '#fd1050',
      color0: '#0cf49b',
      borderColor: '#fd1050',
      borderColor0: '#0cf49b',
      borderWidth: 1,
    },
  },
  graph: {
    itemStyle: {
      borderWidth: 0,
      borderColor: '#ccc',
    },
    lineStyle: {
      width: 1,
      color: '#aaaaaa',
    },
    symbolSize: 4,
    symbol: 'circle',
    smooth: false,
    color: [
      '#dd6b66',
      '#759aa0',
      '#e69d87',
      '#8dc1a9',
      '#ea7e53',
      '#eedd78',
      '#73a373',
      '#73b9bc',
      '#7289ab',
      '#91ca8c',
      '#f49f42',
    ],
    label: {
      color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
    },
  },
  map: {
    itemStyle: {
      areaColor: '#eee',
      borderColor: '#444',
      borderWidth: 0.5,
    },
    label: {
      color: '#000',
    },
    emphasis: {
      itemStyle: {
        areaColor: 'rgba(255,215,0,0.8)',
        borderColor: '#444',
        borderWidth: 1,
      },
      label: {
        color: 'rgb(100,0,0)',
      },
    },
  },
  geo: {
    itemStyle: {
      areaColor: '#eee',
      borderColor: '#444',
      borderWidth: 0.5,
    },
    label: {
      color: '#000',
    },
    emphasis: {
      itemStyle: {
        areaColor: 'rgba(255,215,0,0.8)',
        borderColor: '#444',
        borderWidth: 1,
      },
      label: {
        color: 'rgb(100,0,0)',
      },
    },
  },
  categoryAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
      },
    },
    axisTick: {
      show: true,
      lineStyle: {
        color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
      },
    },
    axisLabel: {
      show: true,
      color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: ['#aaaaaa'],
      },
    },
    splitArea: {
      show: false,
      areaStyle: {
        color: [SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT],
      },
    },
  },
  valueAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
      },
    },
    axisTick: {
      show: true,
      lineStyle: {
        color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
      },
    },
    axisLabel: {
      show: true,
      color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: [SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT],
      },
    },
    splitArea: {
      show: false,
      areaStyle: {
        color: [SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT],
      },
    },
  },
  logAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
      },
    },
    axisTick: {
      show: true,
      lineStyle: {
        color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
      },
    },
    axisLabel: {
      show: true,
      color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: ['#aaaaaa'],
      },
    },
    splitArea: {
      show: false,
      areaStyle: {
        color: [SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT],
      },
    },
  },
  timeAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
      },
    },
    axisTick: {
      show: true,
      lineStyle: {
        color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
      },
    },
    axisLabel: {
      show: true,
      color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: ['#aaaaaa'],
      },
    },
    splitArea: {
      show: false,
      areaStyle: {
        color: [SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT],
      },
    },
  },
  toolbox: {
    iconStyle: {
      borderColor: '#999999',
    },
    emphasis: {
      iconStyle: {
        borderColor: '#666666',
      },
    },
  },
  legend: {
    textStyle: {
      color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
    },
    pageIconColor: SchenckColors.SCHENCK_COLOR_BLUE_LIGHTER,
    pageTextStyle: {
      color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
    },
  },
  tooltip: {
    axisPointer: {
      lineStyle: {
        color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
        width: '1',
      },
      crossStyle: {
        color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
        width: '1',
      },
    },
  },
  timeline: {
    lineStyle: {
      color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
      width: 1,
    },
    itemStyle: {
      color: '#dd6b66',
      borderWidth: 1,
    },
    controlStyle: {
      color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
      borderColor: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
      borderWidth: 0.5,
    },
    checkpointStyle: {
      color: '#e43c59',
      borderColor: '#c23531',
    },
    label: {
      color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
    },
    emphasis: {
      itemStyle: {
        color: '#a9334c',
      },
      controlStyle: {
        color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
        borderColor: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
        borderWidth: 0.5,
      },
      label: {
        color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
      },
    },
  },
  visualMap: {
    color: ['#bf444c', '#d88273', '#f6efa6'],
  },
  dataZoom: {
    backgroundColor: 'rgba(47,69,84,0)',
    dataBackgroundColor: 'rgba(255,255,255,0.3)',
    fillerColor: 'rgba(167,183,204,0.4)',
    handleColor: '#a7b7cc',
    handleSize: '100%',
    textStyle: {
      color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
    },
  },
  markPoint: {
    label: {
      color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
    },
    emphasis: {
      label: {
        color: SchenckColors.SCHENCK_COLOR_GRAY_BRIGHT,
      },
    },
  },
};
